import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { AssetSummary } from "@swipesense/asset-components"
import ExposedAssetVisitListEnhanced from "../ExposedAssetVisitList/ExposedAssetVisitListEnhanced"
import { entitiesPropTypes } from "../../utils/propTypes"

const ExposedAssetVisitListModal = (props) => {
  const [modal, setModal] = useState(false)
  useEffect(() => {
    props.assetId && props.startAt && props.endAt && setModal(true)
  }, [props])

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  return (
    <Modal
      isOpen={modal}
      size={"lg"}
      centered={true}
      className={"exposed-asset-visits"}
    >
      <ModalHeader close={closeButton} />
      <ModalBody>
        {props.assetId && props.startAt && props.endAt && (
          <ExposedAssetVisitListEnhanced {...props} />
        )}
      </ModalBody>
    </Modal>
  )
}

ExposedAssetVisitListModal.propTypes = {
  asset: PropTypes.shape(AssetSummary.propTypes),
  entities: entitiesPropTypes,
  assetId: PropTypes.string,
  startAt: PropTypes.string,
  endAt: PropTypes.string,
}

export default ExposedAssetVisitListModal
